import React from 'react';
import PropTypes from 'prop-types';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import OfferCell from './OfferCell';

const OfferHead = props => {
  const { columns, strings } = props;
  return columns.length > 0 ? (
    <TableHead>
      <TableRow>
        {columns.map(cell => (
          <OfferCell strings={strings} data={cell.label} key={cell.id} />
        ))}
      </TableRow>
    </TableHead>
  ) : undefined;
};
OfferHead.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
      type: PropTypes.oneOf(['string', 'number', 'date', 'boolean', 'currency', 'hybrid']),
    })
  ),
  strings: PropTypes.object.isRequired, // eslint-disable-line
};

OfferHead.defaultProps = {
  columns: [],
};

export default OfferHead;
